// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/text.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/pen.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/bin.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-main-container {
    display: flex;
    background: #fff;
    padding: 20px;
    height: 297px;
    gap: 10px;
}

.group-pens-wrap {
    width: 180px;
    border: 1px #000 solid;
    padding: 0;
    margin: 0;
    overflow-y: scroll;
}
.dropdown-list {
    border: 1px solid #000;
    padding: 0;
    margin: 0;
}

.group-selected-wrap {
    margin: 0;
    padding: 0;
    width: 220px;
    border: 1px solid #000;
}

.group-title {
    padding-bottom: 10px
}

.group-input,
.group-select {
    width: 153px;
    border: 1px solid #000;
    height: 26px;
    line-height: 26px;
    padding-left: 15px;
    cursor: pointer;
}

.group-input {
    display: none;
}
.control-btns{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: top;
}
.control-btns svg{
    cursor: pointer;
}
.control-btns svg.disable path{
    fill: #B3B3B3;
}
.control-btns svg.active path{
    fill: #1E90FF;
}
.group-icon-txt,
.group-icon-pen,
.group-icon-bin {
    cursor: pointer;
}

    .group-icon-txt:before {
        content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    }

    .group-icon-pen:before {
        content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    }

    .group-icon-bin:before {
        content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    }

.group-control svg {
    width: 23px;
}

.group-control.left {
    transform: rotate(180deg);
}

.group-controls-wrap {
    display: flex;
    padding-bottom: 10px;
}

.group-buttons-wrap {
    display: flex;
    gap: 20px;
    padding-top: 10px;
}

.group-btn {
    cursor: pointer;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    padding: 5px;
    justify-content: center;
    width: calc(100% / 2 - 20px);
    color: #fff;
    background: linear-gradient(180deg, #2D72D2 0%, #345DA2 100%), linear-gradient(0deg, #345CA1, #345CA1);
    border-radius: 3px;
    border-width: 1px;
    border-color: #345CA1;
    border-style: solid;
}
.group-btn:disabled{
    background: #B8B8B8;
    border-color: #878888;
    color: #CDCDCD;
}

.groups-right-wrap,
.groups-left-wrap,
.groups-middle-wrap {
    display: flex;
    flex-direction: column;
}

.groups-middle-wrap {
    justify-content: center;
    cursor: pointer;
}

.group-pens-wrap,
.group-selected-wrap {
    flex-grow: 1;
}

.group-pen-wrap {
    display: flex;
    cursor: pointer;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding-right: 10px;
    box-sizing: border-box;
    user-select: none;
}

.group-pen-block {
    display: flex;
}

.group-pen-wrap.active {
    background: #D2E9FF;
    /* opacity: .5; */
}

.group-pen-name {
    font-size: 12px;
    padding: 5px 10px;
}

.group-pen-color {
    width: 3px;
}
.no-group{
    width: 136px;
    border: 1px solid #000;
    height: 24px;
    line-height: 26px;
    padding-left: 15px;
}
.main-pen-icon{
    color: #1E90FF;
}`, "",{"version":3,"sources":["webpack://./src/controls/trend/groups/group.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,UAAU;IACV,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI;AACJ;;AAEA;;IAEI,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;;;IAGI,eAAe;AACnB;;IAEI;QACI,gDAAkC;IACtC;;IAEA;QACI,gDAAiC;IACrC;;IAEA;QACI,gDAAiC;IACrC;;AAEJ;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;IAC5B,WAAW;IACX,sGAAsG;IACtG,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;;IAGI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB","sourcesContent":[".group-main-container {\r\n    display: flex;\r\n    background: #fff;\r\n    padding: 20px;\r\n    height: 297px;\r\n    gap: 10px;\r\n}\r\n\r\n.group-pens-wrap {\r\n    width: 180px;\r\n    border: 1px #000 solid;\r\n    padding: 0;\r\n    margin: 0;\r\n    overflow-y: scroll;\r\n}\r\n.dropdown-list {\r\n    border: 1px solid #000;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.group-selected-wrap {\r\n    margin: 0;\r\n    padding: 0;\r\n    width: 220px;\r\n    border: 1px solid #000;\r\n}\r\n\r\n.group-title {\r\n    padding-bottom: 10px\r\n}\r\n\r\n.group-input,\r\n.group-select {\r\n    width: 153px;\r\n    border: 1px solid #000;\r\n    height: 26px;\r\n    line-height: 26px;\r\n    padding-left: 15px;\r\n    cursor: pointer;\r\n}\r\n\r\n.group-input {\r\n    display: none;\r\n}\r\n.control-btns{\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: top;\r\n}\r\n.control-btns svg{\r\n    cursor: pointer;\r\n}\r\n.control-btns svg.disable path{\r\n    fill: #B3B3B3;\r\n}\r\n.control-btns svg.active path{\r\n    fill: #1E90FF;\r\n}\r\n.group-icon-txt,\r\n.group-icon-pen,\r\n.group-icon-bin {\r\n    cursor: pointer;\r\n}\r\n\r\n    .group-icon-txt:before {\r\n        content: url(\"../assets/text.svg\");\r\n    }\r\n\r\n    .group-icon-pen:before {\r\n        content: url(\"../assets/pen.svg\");\r\n    }\r\n\r\n    .group-icon-bin:before {\r\n        content: url(\"../assets/bin.svg\");\r\n    }\r\n\r\n.group-control svg {\r\n    width: 23px;\r\n}\r\n\r\n.group-control.left {\r\n    transform: rotate(180deg);\r\n}\r\n\r\n.group-controls-wrap {\r\n    display: flex;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.group-buttons-wrap {\r\n    display: flex;\r\n    gap: 20px;\r\n    padding-top: 10px;\r\n}\r\n\r\n.group-btn {\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    line-height: 14px;\r\n    display: flex;\r\n    padding: 5px;\r\n    justify-content: center;\r\n    width: calc(100% / 2 - 20px);\r\n    color: #fff;\r\n    background: linear-gradient(180deg, #2D72D2 0%, #345DA2 100%), linear-gradient(0deg, #345CA1, #345CA1);\r\n    border-radius: 3px;\r\n    border-width: 1px;\r\n    border-color: #345CA1;\r\n    border-style: solid;\r\n}\r\n.group-btn:disabled{\r\n    background: #B8B8B8;\r\n    border-color: #878888;\r\n    color: #CDCDCD;\r\n}\r\n\r\n.groups-right-wrap,\r\n.groups-left-wrap,\r\n.groups-middle-wrap {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.groups-middle-wrap {\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.group-pens-wrap,\r\n.group-selected-wrap {\r\n    flex-grow: 1;\r\n}\r\n\r\n.group-pen-wrap {\r\n    display: flex;\r\n    cursor: pointer;\r\n    width: 100%;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding-right: 10px;\r\n    box-sizing: border-box;\r\n    user-select: none;\r\n}\r\n\r\n.group-pen-block {\r\n    display: flex;\r\n}\r\n\r\n.group-pen-wrap.active {\r\n    background: #D2E9FF;\r\n    /* opacity: .5; */\r\n}\r\n\r\n.group-pen-name {\r\n    font-size: 12px;\r\n    padding: 5px 10px;\r\n}\r\n\r\n.group-pen-color {\r\n    width: 3px;\r\n}\r\n.no-group{\r\n    width: 136px;\r\n    border: 1px solid #000;\r\n    height: 24px;\r\n    line-height: 26px;\r\n    padding-left: 15px;\r\n}\r\n.main-pen-icon{\r\n    color: #1E90FF;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
